export default __webpack_public_path__ + "static/media/Vector8.c9165edd.svg";